import { defineComponent, Teleport } from 'vue'
import { useRouter } from 'vue-router'

import BaseModal from '@/components/base/modal/BaseModal'
import MenuButton from '@/components/common/button/MenuButton'
import VIcon from '@/components/common/VIcon'
import useMenuModal from '@/composables/common/modal/useMenuModal'
import useLocalization from '@/composables/localization/useLocalization'

interface Props {
  modalkey: symbol
}

export default defineComponent<Props>((props) => {
  const mainModal = useMenuModal<boolean>(props.modalkey)
  const router = useRouter()
  const { localeTexts } = useLocalization()

  return () => (
    <Teleport to='body'>
      <BaseModal
        t-data='profile-menu-modal'
        modalkey={mainModal.key}
      >
        <div class='flex w-screen flex-col bg-white pb-2.5 shadow-elevation-10'>
          <div class='flex h-12 w-full items-center justify-end px-4'>
            <button
              t-data='menu-modal-close-btn'
              onClick={() => { mainModal.cancel() }}
            >
              <VIcon
                class='text-[24px]'
                icon='material-symbols:close'
              />
            </button>
          </div>
          <div class='py-2'>
            <MenuButton
              t-data='profile-menu-modal-item-my-account-btn'
              onClick={() => {
                router.push({ name: 'my-account' })
                mainModal.cancel()
              }}
            >
              {localeTexts.value['navigation-menu-item-account-btn']}
            </MenuButton>
            <div class='my-2 h-px w-full bg-neutral-300' />
            <MenuButton
              t-data='profile-menu-modal-item-logout-btn'
              onClick={() => { mainModal.confirm(true) }}
            >
              {localeTexts.value['navigation-menu-item-logout-btn']}
            </MenuButton>
          </div>
        </div>
      </BaseModal>
    </Teleport>
  )
}, {
  name: 'ProfileMenuModal',
  props: ['modalkey']
})
